import { render } from "./RisultatiView.vue?vue&type=template&id=4767ce1c"
import script from "./RisultatiView.vue?vue&type=script&lang=js"
export * from "./RisultatiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__